// extracted by mini-css-extract-plugin
export default {"ModalsContainer":"styles__ModalsContainer-iT2R"};